import index from "../pages/home/index.vue";
export default {
	path: "/",
	name: "home",
	meta: { title: "首页" },
	component: index,
};
